import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../auth//auth.service';
import { Colors, loginApplicationLogo } from '../const';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  model: any = {};
  @ViewChild('loginForm') loginForm;
  badCredentials = false;
  loginApplicationLogo = loginApplicationLogo;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
  }

  onLogin() {
    this.badCredentials = false;
    if (this.loginForm.form.valid) {
      this.authenticationService.login(this.model.email, this.model.password)
      .subscribe(
        (data) => {
          this.router.navigate(['/']);
        },
        (error) => {
          this.badCredentials = true;
          setTimeout(() => {
              this.badCredentials = false;
          }, 2000);
        }
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/common/login/login.component.ts